import React from 'react'
import { Button, Card, Col, Divider, Progress, Row, Typography } from 'antd'
import dashboardStyles from '../styles/dashboardStyles'

const { Text } = Typography

const CollectionPerformance = ({ collectionPerformance = [] }) => {
  return (
    <Card title='Collection Performance' style={dashboardStyles.card}>
      <Row gutter={[16, 16]}>
        {collectionPerformance.map((item, index) => (
          <Col span={24} key={index}>
            <Text>{item.title}</Text>
            <Progress percent={item.percent} status='active' />
          </Col>
        ))}
      </Row>
      <Divider />
      <div style={{ textAlign: 'center' }}>
        <Button type='primary' style={dashboardStyles.primaryButton}>
          Improve Collections
        </Button>
      </div>
    </Card>
  )
}

export default CollectionPerformance
